import React, { useState } from 'react';
import './paymentMethodModal.css';
import { useSelector } from 'react-redux';
import { authenticatedFetch } from '../../../network/api';

const PaymentMethodModal = ({ isOpen, onClose }) => {
  const [paymentType, setPaymentType] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const firmId = useSelector((s) => s.firm.details?.id);


  const handlePaymentTypeSelect = (type) => {
    setPaymentType(type);
    setIsDropdownOpen(false);
  };

  // Create Checkout Session for Setup Mode
  const createCheckoutSession = async (paymentMethodTypes) => {
    setLoading(true);
    try {
      const response = await authenticatedFetch('/api/attorney/webapp/stripe/createStripeCustomer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firmId: firmId, // Replace with actual firm ID from your app state/props
          payment_method_types: paymentMethodTypes,
        }),
      });
      
      const result = await response.json();
      
      if (response.ok) {
        // Redirect to Stripe Checkout
        window.location.href = result.url;
      } else {
        throw new Error(result.error);
      }
      
    } catch (error) {
      console.error('Error creating checkout session:', error);
      setLoading(false);
      // You might want to show an error message to the user here
    }
  };

  const handleContinue = () => {
    if (paymentType === 'credit-card') {
      createCheckoutSession(['card']);
    } else if (paymentType === 'ach') {
      createCheckoutSession(['us_bank_account']);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <div className="payment-modal-header">
          <h2>Add new payment method</h2>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="payment-modal-content">
          <div className="payment-type-selection">
            <div className="form-group">
              <label>Payment method type</label>
              <div className="dropdown-container">
                <div className="dropdown-header" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                  <span className="dropdown-placeholder">
                    {paymentType ? (paymentType === 'credit-card' ? 'Credit card' : 'ACH account') : 'Select'}
                  </span>
                  <span className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>▼</span>
                </div>
                {isDropdownOpen && (
                  <div className="dropdown-options">
                    <div 
                      className="dropdown-option"
                      onClick={() => handlePaymentTypeSelect('credit-card')}
                    >
                      Credit card
                    </div>
                    <div 
                      className="dropdown-option"
                      onClick={() => handlePaymentTypeSelect('ach')}
                    >
                      ACH account
                    </div>
                  </div>
                )}
              </div>
            </div>

            {paymentType && (
              <div style={{ 
                marginTop: '1.5rem', 
                padding: '1rem', 
                backgroundColor: '#f8f9fa', 
                borderRadius: '4px',
                border: '1px solid #e8e9eb'
              }}>
                <p style={{ 
                  margin: '0 0 0.5rem 0', 
                  fontSize: '14px', 
                  color: '#333333',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '500'
                }}>
                  {paymentType === 'credit-card' ? 'Credit Card Setup' : 'ACH Account Setup'}
                </p>
                <p style={{ 
                  margin: '0', 
                  fontSize: '13px', 
                  color: '#666666',
                  fontFamily: 'Poppins, sans-serif',
                  lineHeight: '1.4'
                }}>
                  You'll be redirected to Stripe's secure checkout to add your {paymentType === 'credit-card' ? 'credit card' : 'bank account'} details. 
                  No charges will be made - this is only to save your payment method for future monthly billing.
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="payment-modal-footer">
          <div className="footer-buttons">
            <button 
              className="save-button" 
              onClick={handleContinue}
              disabled={!paymentType || loading}
            >
              {loading ? 'Redirecting...' : 'Continue to Stripe'}
            </button>
            <button className="cancel-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>

        {paymentType === 'ach' && (
          <div className="disclaimer">
            Your use of a paid Quidpro service authorizes Quidpro to charge your practice.
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodModal;